import {
    USER_LIST_REQUEST,
    USER_LIST_SUCCESS,
    USER_LIST_FAIL,
    USER_LIST_RESET,

    USER_DELETE_REQUEST,
    USER_DELETE_SUCCESS,
    USER_DELETE_FAIL,
} from '../constants/userConstants';


export const userListReducer = (state = { users: [], loading: false, error: "" }, action) => {
    switch (action.type) {
        case USER_LIST_REQUEST:
            return { users: [], loading: true, error: "" };
        case USER_LIST_SUCCESS:
            return { users: action.payload, loading: false, error: "" };
        case USER_LIST_FAIL:
            return { users: [], loading: false, error: action.payload };
        case USER_LIST_RESET:
            return { users: [], loading: false, error: "" };
        default:
            return state;
    }
};


export const userDeleteReducer = (state = { loading: false, success: false }, action) => {
    switch (action.type) {
        case USER_DELETE_REQUEST:
            return { loading: true, success: false };
        case USER_DELETE_SUCCESS:
            return { loading: false, success: true };
        case USER_DELETE_FAIL:
            return { loading: false, error: action.payload, success: false };
        default:
            return state;
    }
};
